import React from 'react'
import { TICKET_TOPICS } from '../../../../shared/ticketTopics.js'

/**
 * The topic on an open ticket, changeable in one pick (inbox deflection W1).
 * `onChange(topic)` saves it; the parent owns the request and the state.
 */
export default function TopicPicker({ topic, onChange, disabled = false }) {
  return (
    <select
      className="form-input"
      value={topic || ''}
      onChange={e => { if (e.target.value) onChange(e.target.value) }}
      disabled={disabled}
      style={{ width: 'auto', minWidth: 160, fontSize: 12 }}
      aria-label="Ticket topic"
    >
      {!topic && <option value="">Set topic</option>}
      {TICKET_TOPICS.map(option => (
        <option key={option.key} value={option.key}>{option.label}</option>
      ))}
    </select>
  )
}
